import api from "./client";
import type {
  KakaoLoginResponse,
  EmailLoginResponse,
  RegisterResponse,
  AdminLoginResponse,
  PhoneSendResponse,
  PhoneVerifyResponse,
} from "@/types/api";

// 카카오 로그인
export const kakaoLogin = (code: string): Promise<KakaoLoginResponse> =>
  api.post("/v1/auth/kakao", { code }).then((res) => res.data.data);

// 이메일 회원가입 (휴대폰 인증 완료 후)
export const emailSignup = (
  email: string,
  password: string,
  phoneVerifiedToken: string,
): Promise<EmailLoginResponse> =>
  api.post("/v1/auth/signup/email", { email, password, phoneVerifiedToken }).then((res) => res.data.data);

// 이메일 로그인
export const emailLogin = (email: string, password: string): Promise<EmailLoginResponse> =>
  api.post("/v1/auth/login/email", { email, password }).then((res) => res.data.data);

// 약관 동의 (카카오 신규 유저 회원가입 완료)
export const register = (agreeTerms: boolean, agreePrivacy: boolean): Promise<RegisterResponse> =>
  api.post("/v1/auth/register", { agreeTerms, agreePrivacy }).then((res) => res.data.data);

// 인증번호 발송
export const phoneSend = (phoneNumber: string): Promise<PhoneSendResponse> =>
  api.post("/v1/auth/phone/send", { phoneNumber }).then((res) => res.data.data);

// 인증번호 확인
export const phoneVerify = (verificationToken: string, code: string): Promise<PhoneVerifyResponse> =>
  api.post("/v1/auth/phone/verify", { verificationToken, code }).then((res) => res.data.data);

// 비밀번호 재설정
export const resetPassword = (
  email: string,
  phoneVerifiedToken: string,
  newPassword: string,
): Promise<{ success: boolean }> =>
  api.post("/v1/auth/password/reset-email-phone", { email, phoneVerifiedToken, newPassword }).then((res) => res.data.data);

// 로그아웃
export const logout = (): Promise<void> =>
  api.post("/v1/auth/logout").then(() => undefined);

// 관리자 로그인
export const adminLogin = (
  email: string,
  password: string,
): Promise<AdminLoginResponse> =>
  api.post("/v1/auth/admin/login", { email, password }).then((res) => res.data.data);
